import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

import { BaseFlatFieldDefinition, BaseNestedFieldDefinition, FieldDefinition, FieldType } from '@stylehaven/components';

import { SHORT_DATE_FORMAT } from './constants';

@Injectable()
export class FieldDefinitionHelper {
    constructor(private readonly datePipe: DatePipe) {}

    public static nestFlatFieldDefinitions(fieldDefs: BaseFlatFieldDefinition[]): BaseNestedFieldDefinition[] {
        return fieldDefs.map(flat => FieldDefinitionHelper.nestFlatFieldDefinition(flat, fieldDefs));
    }

    public static nestFlatFieldDefinition(
        flat: BaseFlatFieldDefinition,
        all: BaseFlatFieldDefinition[]
    ): BaseNestedFieldDefinition {
        const children = flat.ChildrenFlat?.map(childFlat =>
            all.find(def => def.FieldDefinitionId === childFlat.FieldDefinitionId)
        )
            .filter((childDef): childDef is BaseFlatFieldDefinition => !!childDef)
            .map(childFlat => FieldDefinitionHelper.nestFlatFieldDefinition(childFlat, all));

        return {
            ...flat,
            Children: children ?? []
        };
    }

    static extractFlatKeys(fieldDefinitions: FieldDefinition[]): string[] {
        return fieldDefinitions.map(fieldDefinition => fieldDefinition.FlatKey);
    }

    convertToString(fieldType: FieldType, value: any): string {
        switch (fieldType) {
            case FieldType.SimpleField:
                return this.parseString(value);
            case FieldType.LongField:
                return this.parseNumber(value);
            case FieldType.DateField:
                return this.parseDate(value);
            default:
                return this.parseString(value);
                break;
        }
    }

    private parseNumber(value: number): string {
        const defaultValue = 0;

        if (typeof value === 'number') {
            return value.toString();
        }

        return defaultValue.toString();
    }

    private parseString(value: string): string {
        const defaultValue = '';

        if (typeof value === 'string') {
            return value;
        }

        return defaultValue;
    }

    private parseDate(value: Date): string {
        const defaultValue = '';

        if (value instanceof Date) {
            return this.datePipe.transform(value, SHORT_DATE_FORMAT) || defaultValue;
        }

        return defaultValue;
    }
}
